module.exports = __webpack_public_path__ + "img/nav_b1_img1.0de840ed.png";